import { useState, useEffect, useContext } from "react";
import {
  registerPresence,
  subscribeToPlayerCount,
} from "../services/firebase/presenceService";
import { AuthContext } from "../components/Providers/AuthContext";

/**
 * Hook to get real-time count of players online
 * Also registers this user's presence when mounted
 *
 * @returns Current number of players online
 */
export function usePlayersOnline(): number {
  const [count, setCount] = useState<number>(1); // Start with 1 (current user)
  const { user } = useContext(AuthContext);

  useEffect(() => {
    // Register this user's presence (with uid for friend online tracking)
    registerPresence(user?.uid);

    // Subscribe to real-time player count updates
    const unsubscribe = subscribeToPlayerCount((newCount) => {
      // Ensure we always show at least 1 (the current user)
      setCount(Math.max(1, newCount));
    });

    // Cleanup subscription on unmount
    // Note: We don't remove presence on unmount because the user might
    // still be on the site in another component. The presence service
    // handles cleanup on page unload.
    return () => {
      unsubscribe();
    };
  }, [user?.uid]);

  return count;
}
